export default __webpack_public_path__ + "static/media/maUSDC-USDC.0fc6c9cb.png";